<div class="container">

  <app-contact [(show)]="showContact"
               [ngStyle]="{'display': firstLoad? 'none' : 'unset'}"
               [ngClass]="{'show-contact': showContact, 'hide-contact': !showContact && !firstLoad}">
  </app-contact>
  <button vertical="true"
          [ngClass]="{'hide-button': showContact, 'show-button': !showContact && !firstLoad }"
          (click)="hideOrShowContact()">
    <p>CONTATO</p>
  </button>
  <!--              [ngStyle]="{display: showContact? 'none' : 'unset'}"-->


</div>
